module.exports = __webpack_public_path__ + "img/thumb_image5.2ec3bac9.jpg";